import { service } from '../../../../helpers/http'

export const ActionIndexDynamicDivisions = ({ dispatch }, payload) => {

    return service({
        module: 'dynamicGeneration',
        action: 'indexDynamicDivisions',
        payload: payload
    })
    
}

export const ActionCreateDynamicDivision = ({ dispatch }, payload) => {
    
    return service({
        module: 'dynamicGeneration',
        action: 'createDynamicDivision',
        payload: payload
    })
    
}

export const ActionUpdateDynamicDivision = ({ dispatch }, payload) => {
    
    return service({
        module: 'dynamicGeneration',
        action: 'updateDynamicDivision',
        payload: payload
    })
}

export const ActionDeleteDynamicDivision = ({ dispatch }, payload) => {
    
    return service({
        module: 'dynamicGeneration',
        action: 'deleteDynamicDivision',
        payload: payload
    })
    
}

export const ActionDynamicDivisionGenerate = ({ dispatch }, payload) => {

    return service({
        module: 'dynamicGeneration',
        action: 'generateDynamicDivision',
        payload: payload
    })
    
}

export const ActionDynamicDivisionSync = ({ dispatch }, payload) => {

    return service({
        module: 'dynamicGeneration',
        action: 'syncDynamicDivision',
        payload: payload
    })
    
}

export const ActionIndexDynamicDivisionTypes = ({ dispatch }, payload) => {

    return service({
        module: 'dynamicGeneration',
        action: 'indexDynamicDivisionTypes',
        payload: payload
    })
    
}


